import { Badge, Card, Text } from '../../../core';
import { surfaceHeaderProps } from '../SurfaceHeader';

export interface RiskScoreCardProps {
  readonly score: number;
  readonly label: string;
  readonly context?: string;
  readonly trend?: 'up' | 'down' | 'flat';
}

const SCORE_COLOR = (score: number): string => {
  if (score >= 75) return 'green';
  if (score >= 50) return 'yellow';
  return 'red';
};

const TREND_LABEL: Record<NonNullable<RiskScoreCardProps['trend']>, string> = {
  up: '↑ Improving',
  down: '↓ Declining',
  flat: '→ Stable',
};

export function RiskScoreCard({
  score,
  label,
  context,
  trend,
}: RiskScoreCardProps) {
  return (
    <Card withBorder radius="md" p="md" style={{ width: '100%' }}>
      <div {...surfaceHeaderProps('md')}>
        <Text fw={600} size="sm" c="dimmed">
          {label}
        </Text>
      </div>

      <Badge color={SCORE_COLOR(score)} size="xl" radius="sm" mb={8}>
        {score} / 100
      </Badge>

      {context && (
        <Text size="sm" c="dimmed" mb={4}>
          {context}
        </Text>
      )}

      {trend && (
        <Text size="xs" c="dimmed">
          {TREND_LABEL[trend]}
        </Text>
      )}
    </Card>
  );
}
